<ion-refresher (ionRefresh)="onRefresh($event)" slot="fixed">
  <ion-refresher-content></ion-refresher-content>
</ion-refresher>
<div *ngIf="ascents && ascents.length===0">
  <p style="text-align: center">{{"my-ascent-list-component.no-ascents-yet" |translate}}</p>
</div>
<ion-list *ngIf="ascents else loading">
  <ion-grid *ngIf="ascents.length>0">
    <ion-row>
      <ion-col>
        <ion-item>
          <ion-toggle mode="md" [(ngModel)]="onlyRanking" justify="start"
                      (ngModelChange)="reloadAscents()">{{"my-ascent-list-component.only-top" |translate}}{{maxBoulderInRanking}}</ion-toggle>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-item>
          <ion-label class="heading">
            {{ascents.length}} {{(ascents.length == 1 ? "my-ascent-list-component.ascent" : "my-ascent-list-component.ascents") | translate}}
            <span *ngIf="numFlashed>0">
            ({{numFlashed}} {{(numFlashed == 1 ? "my-ascent-list-component.flash" : "my-ascent-list-component.flashs") | translate}}
              )</span>
            <span *ngIf="onlyRanking">
            , <ion-chip class="points-chip" *ngIf="onlyRanking">{{totalScore}} </ion-chip>
              {{"my-ascent-list-component.points-in-ranking" |translate}}
          </span>
          </ion-label>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div *ngIf="ascents">
    <my-ascent-list-entry *ngFor="let ascent of ascents" [showPoints]="onlyRanking" [ascent]="ascent"></my-ascent-list-entry>
  </div>
</ion-list>
<ng-template #loading>
  <br><br>
  <h2>{{"ascent-list-component.loading-ascents" | translate}}</h2>
  <p>{{"shared.please-wait" | translate}}</p>
</ng-template>
